import { z } from 'zod'
import { NewPassword, PASSWORD_MAX_CHARS } from '../password'
import { Id } from './primitives'

export const PASSWORD_REFUSAL_REASONS = ['has_account', 'other_workspace', 'self'] as const
export type PasswordRefusalReason = (typeof PASSWORD_REFUSAL_REASONS)[number]

export const PASSWORD_REFUSAL_MESSAGES: Record<PasswordRefusalReason, string> = {
  has_account:
    '這個 email 已經有自己的登入帳號，所以不能由你設定密碼。請不設密碼直接邀請，對方會用自己現有的密碼登入。',
  other_workspace:
    '這個 email 已經屬於或正被邀請加入另一個工作區，為了保障那邊的資料，不能由你設定密碼。請不設密碼直接邀請，對方會用自己的帳號登入。',
  self: '不能在這裡重設自己的密碼，請到「設定」的「更改密碼」更改。',
}

export const ResetMemberPasswordRequest = z.strictObject({ password: NewPassword })
export type ResetMemberPasswordRequest = z.infer<typeof ResetMemberPasswordRequest>

export const ResetMemberPasswordResponse = z.object({ userId: Id, passwordChangeRequired: z.literal(true) })
export type ResetMemberPasswordResponse = z.infer<typeof ResetMemberPasswordResponse>

export const PasswordChangeStatus = z.object({ passwordChangeRequired: z.boolean() })
export type PasswordChangeStatus = z.infer<typeof PasswordChangeStatus>

export const SuppliedPassword = z.string().min(1).max(PASSWORD_MAX_CHARS)

export const ChangePasswordRequest = z.strictObject({ currentPassword: SuppliedPassword, newPassword: NewPassword })
export type ChangePasswordRequest = z.infer<typeof ChangePasswordRequest>

export const SINGLE_WORKSPACE_MESSAGES = {
  memberElsewhere:
    '這個 email 已經屬於另一個工作區。目前每個帳號只可以屬於一個工作區，所以不能邀請。如有需要，請聯絡 Red Digital。',
  secondWorkspace: '目前平台只可以有一個工作區，已經有一個在使用中，所以不能再建立新的工作區。',
} as const
